'use strict';

module.exports = function (row, column, index, h) {

  var value = this._getValue(row, column);

  if (this.templatesKeys.indexOf(column) == -1) {

    if (typeof value === 'undefined' || !this.opts.highlightMatches || this.filterableColumns.indexOf(column) === -1) {
      return value;
    }

    return this.highlightMatch(value, column, h);
  }

  var template = this.opts.templates[column];

  template = typeof template == 'function' ? template.apply(this.$root, [h, row, index, column]) : h(template, {
    attrs: {
      data: row,
      column: column,
      index: index
    }
  });

  return template;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/render.js
// module id = 1486
// module chunks = 0